var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcon20Link2 = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.472 9.222a.69.69 0 0 1-.49-.203 2.78 2.78 0 0 0-3.927 0 .694.694 0 1 1-.981-.982 4.168 4.168 0 0 1 5.889 0 .694.694 0 0 1-.49 1.185zM10.982 13.181a4.151 4.151 0 0 1-2.945-1.218.694.694 0 1 1 .981-.98 2.78 2.78 0 0 0 3.927 0 .694.694 0 1 1 .981.98 4.152 4.152 0 0 1-2.944 1.218z",
    fill: "#029D8B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.435 12.166a.694.694 0 0 1-.49-1.185l3.876-3.876a.694.694 0 1 1 .981.981l-3.876 3.877a.69.69 0 0 1-.491.203zM7.595 18.006a.694.694 0 0 1-.49-1.185l2.167-2.167a.694.694 0 1 1 .981.982l-2.167 2.167a.69.69 0 0 1-.49.203zM2.688 13.099a.694.694 0 0 1-.49-1.185l3.876-3.877a.694.694 0 1 1 .981.982L3.18 12.895a.693.693 0 0 1-.491.204zM10.237 5.55a.692.692 0 0 1-.49-1.185l2.167-2.168a.694.694 0 0 1 .981.982l-2.167 2.167a.695.695 0 0 1-.49.203z",
    fill: "#029D8B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.142 19c-1.074 0-2.147-.4-2.945-1.197-1.596-1.597-1.596-4.293 0-5.89a.694.694 0 1 1 .982.982c-1.064 1.064-1.064 2.862 0 3.926s2.862 1.064 3.926 0a.694.694 0 1 1 .981.981A4.15 4.15 0 0 1 5.142 19zM17.312 8.29a.694.694 0 0 1-.49-1.185c1.063-1.064 1.063-2.862 0-3.926-1.065-1.064-2.863-1.064-3.927 0a.694.694 0 1 1-.981-.982c1.596-1.596 4.293-1.596 5.889 0 1.596 1.597 1.596 4.293 0 5.89a.693.693 0 0 1-.491.203z",
    fill: "#029D8B",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon20Link2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-20-link-2.c0926045.svg";
export { ForwardRef as ReactComponent };